import styled from 'styled-components/native';
import { withDefaultTypographyProps } from '@sp/ui/v2/typography/index.shared';

const Body = styled(withDefaultTypographyProps)`
  font-size: ${(props) => props.theme.FONT_SIZES.V2_BODY.DEFAULT}px;
  line-height: ${(props) => props.theme.FONT_SIZES.V2_BODY.DEFAULT * 1.5}px;
  font-style: ${(props) => props.fontStyle};
`;

Body.defaultProps = {
  fontWeight: 'regular',
  fontStyle: 'normal',
};

export default Body;
